module.exports = __webpack_public_path__ + "img/icon-edit-dash.4f77f189.svg";